import { Images, Tweens } from "@abcya/abcya_phaser";
import gameData from "../gameData";
import UIAssetKeys from "../UIAssetKeys";

export default class GatorSmall extends Phaser.GameObjects.Container
{
	constructor(scene)
	{
		super(scene)

		this.jawB = null;
		this.headB = null;

		this.headCont = null;
		this.headContB = null;

		this.tween1 = null;
		this.tween2 = null;

		this.gatorCont = this.scene.add.container();

		this.headCont = this.scene.add.container();
		this.gatorCont.add(this.headCont);

		this.head = Images.addImage(0, 0, UIAssetKeys._HeadTop1, this.headCont).setOrigin(0);
		this.jaw = Images.addImage(0, 0, UIAssetKeys._LowerJaw1, this.headCont).setOrigin(0);

		this.head.setOrigin(.1, .2);
		this.jaw.setOrigin(.1, .5);

		this.head.setPosition(20, -50);
		this.jaw.setPosition(64, 10);

		this.headCont.setScale(.3, .3);
		this.headCont.setPosition(210, 30);
		this.headCont.angle = 45;
		this.headCont.alpha = 0;		
		
		this.headContB = this.scene.add.container();
		this.gatorCont.add(this.headContB);

		this.headB = Images.addImage(0, 0, UIAssetKeys._HeadTop1, this.headContB).setOrigin(0);
		this.jawB = Images.addImage(0, 0, UIAssetKeys._LowerJaw1, this.headContB).setOrigin(0);

		this.headB.setOrigin(.1, .2);
		this.jawB.setOrigin(.1, .5);

		this.headB.setPosition(20, -50);
		this.jawB.setPosition(64, 10);

		this.headContB.setScale(-.3, .3);
		this.headContB.setPosition(240, 65);
		this.headContB.angle = 45;
		this.headContB.alpha = 0;	
	}

	chomp(dir){
		//console.log(dir);

		this.tween1 = Tweens.addTween(this.jaw, 100, {angle: 15, loop: 3, yoyo: true}, Phaser.Math.Easing.Quadratic.InOut);
		this.tween2 = Tweens.addTween(this.jawB, 100, {angle: 15, loop: 3, yoyo: true}, Phaser.Math.Easing.Quadratic.InOut);
	
		this.move(dir);
	};

	move(dir){
		let yAdj;
		let xAdj;
		let aAdj;
	
		if(gameData.questions === 7){
			if(gameData.score === 0){
				xAdj = 0;
				yAdj = 0;
				aAdj = 0;
			}
			else if(gameData.score === 1){
				xAdj = 35;
				yAdj = 53;
				aAdj = -7;
			}
			else if(gameData.score === 2){
				xAdj = 83;
				yAdj = 118;
				aAdj = -17;
			}
			else if(gameData.score === 3){
				xAdj = 125;
				yAdj = 145;
				aAdj = -21;
	
			}
			else if(gameData.score === 4){
				xAdj = 190;
				yAdj = 200;
				aAdj = -36;
			}
			else if(gameData.score === 5){
				xAdj = 260;
				yAdj = 230;
				aAdj = -48;
			}
			else if(gameData.score === 6){
				xAdj = 330;
				yAdj = 250;
				aAdj = -58;
			}
			else if(gameData.score === 7){
				xAdj = 390;
				yAdj = 240;
				aAdj = -65;
			}
		}
		else if(gameData.questions === 10){
			if(gameData.score === 0){
				xAdj = 0;
				yAdj = 0;
				aAdj = 0;
			}
			else if(gameData.score === 1){
				xAdj = 31;
				yAdj = 50;
				aAdj = -7;
			}
			else if(gameData.score === 2){
				xAdj = 63;
				yAdj = 108;
				aAdj = -17;
			}
			else if(gameData.score === 3){
				xAdj = 95;
				yAdj = 135;
				aAdj = -21;
	
			}
			else if(gameData.score === 4){
				xAdj = 135;
				yAdj = 180;
				aAdj = -31;
			}
			else if(gameData.score === 5){
				xAdj = 180;
				yAdj = 210;
				aAdj = -38;
			}
			else if(gameData.score === 6){
				xAdj = 230;
				yAdj = 240;
				aAdj = -48;
			}
			else if(gameData.score === 7){
				xAdj = 285;
				yAdj = 250;
				aAdj = -55;
			}
			else if(gameData.score === 8){
				xAdj = 340;
				yAdj = 260;
				aAdj = -62;
			}
			else if(gameData.score === 9){
				xAdj = 400;
				yAdj = 270;
				aAdj = -74;
			}
			else if(gameData.score === 10){
				xAdj = 445;
				yAdj = 260;
				aAdj = -78;
			}
		}
	
		this.alpha = 1;
	
		this.tween1 = Tweens.addTween(this.gatorCont, 500, {x: xAdj, y:yAdj, angle: aAdj}, Phaser.Math.Easing.Quadratic.InOut,);
	
		if(dir > 0) {
			this.headCont.alpha = 1;
			this.tween2 = Tweens.addTween(this.headCont, 300, {alpha: 0, delay: 500}, Phaser.Math.Easing.None);
		} else {
			this.headContB.alpha = 1;
			this.tween2 = Tweens.addTween(this.headContB, 300, {alpha: 0, delay: 500}, Phaser.Math.Easing.None);
		}
	};
}